import { render } from "./ChatsManualView.vue?vue&type=template&id=7b408c84&ts=true"
import script from "./ChatsManualView.vue?vue&type=script&lang=ts"
export * from "./ChatsManualView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__